import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import RedirectToStorePrompt from 'components/transactions/RedirectToStorePrompt';
import { PermissionCodes } from 'config/PermissionCodes';
import { CreateTransactionError } from 'models/CreateTransactionModel';

import { createAction } from 'utils/index';

import './StoreSelectDropdown.scss';

function StoreSelectDropdown(props) {
  const dispatch = useDispatch();

  const defaultSelectedStore = props.selectedStore;
  const selectStore = props.selectStore || (() => {});
  const hideAddButton = props.hideAddButton || false;
  const defaultFilter = props.defaultFilter;
  const title = props?.title ?? null;
  const hideDeleteButton = props?.hideDeleteButton ?? false;
  const errors = props.errors;
  const errorName = props.errorName;
  const { storeList, errorFields } = useSelector((state) => ({
    storeList: state.storeModel.storeList || [],
    errorFields: state.createTransaction.errorFields,
  }));
  const [showPrompt, setShowPrompt] = useState(false);
  const lastRefreshDateRef = useRef(new Date());
  const [refreshDate, setRefreshDate] = useState(lastRefreshDateRef.current);

  useEffect(() => {
    dispatch(
      createAction('storeModel/getPagedStoreList')({
        ...defaultFilter,
        isSelectorLoad: true,
        search: '',
        active: 'true',
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <CustomTitleWithDropDown
        customClass="store-filter-dropdown"
        title={title}
        hideDeleteButton={hideDeleteButton}
        defaultValue={{
          value: defaultSelectedStore,
          label: defaultSelectedStore?.displayStoreName,
        }}
        source={storeList}
        customItem={(item) => `[ID: ${item?.pk}] ${item?.name}`}
        customItemDisabled={props?.customItemDisabled}
        setValue={(item) => {
          selectStore(item.value);
        }}
        addButtonInfo={
          hideAddButton
            ? null
            : {
                title: 'Add',
                action: () => setShowPrompt(true),
                customClass:
                  'general-section-add-new-brand btn-add-button-common',
                requires: PermissionCodes.addStore,
              }
        }
        errors={errors || errorFields}
        errorName={errorName || CreateTransactionError.store.name}
        loadMoreAction={'storeModel/getPagedStoreList'}
        filterAction={'storeModel/getPagedStoreList'}
        defaultFilter={defaultFilter}
        isReset={lastRefreshDateRef.current !== refreshDate}
        resetChange={() => {
          lastRefreshDateRef.current = refreshDate;
        }}
      />
      <RedirectToStorePrompt
        show={showPrompt}
        onHide={() => {
          setShowPrompt(false);
        }}
        onRefresh={() => {
          setRefreshDate(new Date());
          setShowPrompt(false);
        }}
      />
    </div>
  );
}

export default StoreSelectDropdown;
